import * as React from 'react';
import { CalendarEvent } from '../../../EventsStore/Types';
import EventTimeEntry from './EventTimeEntry';

interface Props {
  event: CalendarEvent;
}

const EventEndOn: React.FC<Props> = ({ event }) => {
  switch (event.kind) {
    case 'upcoming-event':
    case 'current-coaching-event':
    case 'live-event':
      return <EventTimeEntry title="Ends" date={event.endAt} format="time-of-day" />;
    case 'other-event':
    case 'past-event':
      return <></>;
  }
};

export default EventEndOn;
